import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Row,
  Col,
  Button,
  Image,
  Modal,
  Spinner,
} from "react-bootstrap";
import { Upload } from "antd";
import ImgCrop from "antd-img-crop";
import SimpleSelectComponent from "../../components/SimpleSelect/SimpleSelectComponent";
import DatePicker from "react-datepicker";
import { Link, useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import InputMask from "react-input-mask";
// import bgImg from "../../assets/images/main-bg.png";
import IndianicLogo from "../../assets/images/_indianic-white-logo.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  emailValidator,
  getItem,
  getParsedItem,
  removeItem,
  showErrorToast,
  showSuccessToast,
  textValidator,
} from "../../utils/Functions";
import MultiSelectComponent from "../../components/Multiselect/MultiSelectComponent";
import {
  addCandidateData,
  addCvDetails,
  candidateFileUpload,
  countryCodeListing,
  getFormSetting,
  getQualificationList,
  getSkillDetails,
  getWalkInDriveDetails,
  candidateFileDelete,
} from "../Career/action";
import PhoneInput from "react-phone-input-2";
import mammoth from "mammoth/mammoth.browser.min.js";
import "react-phone-input-2/lib/style.css";
import docIcon from "../../assets/images/icons-doc.png";
import BulkImport from "./BulkImport";

const ConsultantForm = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const timeOut = useRef();
  const code = useSelector((state) => state.career.getCountryCode.data);
  const skillDetail = useSelector((state) => state.career.getSkillList.data);
  const addJob = useSelector((state) => state.career.addJobOpening);
  const qualificationDetail = useSelector(
    (state) => state.career.getQualificationDetails
  );
  const walkinDriveSourceDetail = useSelector(
    (state) => state.career.getWalkInDrivedetails.data
  );
  const walkinStatus = useSelector((state) => state.career.walkinDriveStatus);
  const [walkinDriveSourceOption, setWalkinDriveSourceOption] = useState([]);
  const [skillSetOption, setSkillSetOption] = useState([]);
  const [selectedSkill, setSelectedSkill] = useState([]);
  const [phoneCodeOptionsData, setPhoneCodeOptionsData] = useState([]);
  const [startMonth, setStartMonth] = useState("");
  const [experienceStartMonth, setExperienceStartMont] = useState();
  const [preview, setPreview] = useState();
  const [showPreview, setShowPreview] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [profileList, setProfileList] = useState([]);
  const [fileType, setFileType] = useState("");
  const [file, setFile] = useState();
  const [parsingResume, setParsingResume] = useState(false);
  const [uploadMode, setUploadMode] = useState("single");
  const [image, setImage] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [walkinDrive, setWalkinDrive] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [replacingResume, setReplacingResume] = useState(false);
  const [showReplace, setShowReplace] = useState(false);
  const [showDuplicate, setShowDuplicate] = useState(false);
  const [showDocPreview, setShowDocPreview] = useState(false);
  const docPreviewRef = useRef();
  const replaceInput = useRef();
  const replaceMode = useRef("all");
  const [avatarMenu, setAvatarMenu] = useState(false);
  const [showCamera, setShowCamera] = useState(false);
  const avatarBlock = useRef();
  const videoRef = useRef();
  const streamRef = useRef();
  const [consultantData, setConsultantData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    phoneCode: { label: "+91", value: "+91" },
    noticePeriod: "",
    currentEmployer: "",
    totalExperiance: "",
    currentSalary: "",
    skillSet: "",
    educationalDetails: [],
    experienceDetails: [],
    source: "",
    sourceName: "",
    summary: "",
    street: "",
    zipCode: "",
    city: "",
    state: "",
    country: "",
    qualificationId: "",
    qualification: "",
    walkinDriveSourceId: "",
    walkinDriveSource: "",
  });
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    noticePeriod: "",
    currentEmployer: "",
    totalExperiance: "",
    currentSalary: "",
    skillSet: "",
    educationalDetails: [],
    experienceDetails: [],
    source: "",
    sourceName: "",
    summary: "",
    street: "",
    zipCode: "",
    city: "",
    state: "",
    country: "",
    qualificationId: "",
    qualification: "",
  });
  const [educationDetails, setEducationDetails] = useState([
    {
      institute: "",
      major: "",
      degree: "",
      from: "",
      to: "",
      pursuing: false,
    },
  ]);
  const [experienceDetails, setExperienceDetails] = useState([
    {
      occupation: "",
      company: "",
      summary: "",
      from: "",
      to: "",
      isWorking: false,
    },
  ]);

  useEffect(() => {
    document.title = "Consultant Form";
    const query = new URLSearchParams(location.search);
    const keyName = query.get("key");
    keyName && dispatch(getFormSetting(keyName));
  }, []);

  useEffect(() => {
    if (skillDetail && skillDetail.length > 0) {
      const list = [];
      skillDetail?.map((item) => {
        return list.push({
          label: item?.skill,
          value: item?._id,
        });
      });
      setSkillSetOption(list);
    } else {
      setSkillSetOption([]);
    }
  }, [skillDetail]);

  useEffect(() => {
    if (addJob && addJob.status === 1) {
      setIsLoading(false);
      let payload = new FormData();
      payload.append("userId", addJob?.data?._id);
      payload.append("type", "resume");
      payload.append("file", file);
      dispatch(candidateFileUpload(payload));
      setShow(true);
    } else if (addJob && addJob.status === 0) {
      setIsLoading(false);
      setShowDuplicate(true);
    }
  }, [addJob]);


  useEffect(() => {
    if (walkinDriveSourceDetail && walkinDriveSourceDetail.length > 0) {
      const list = [];
      walkinDriveSourceDetail?.map((item) => {
        return list.push({
          label: item?.walkInDrive,
          value: item?._id,
        });
      });
      setWalkinDriveSourceOption(list);
    } else {
      setWalkinDriveSourceOption([]);
    }
  }, [walkinDriveSourceDetail]);

  useEffect(() => {
    dispatch(countryCodeListing());
    setSkillSetOption([]);
    dispatch(getQualificationList());
    dispatch(getWalkInDriveDetails());
  }, []);

  useEffect(() => {
    if (code && code.length > 0) {
      const list = [];
      code?.map((item) => {
        list.push({
          label: `+${item?.phoneCode}`,
          value: `+${item?.phoneCode}`,
        });
        setPhoneCodeOptionsData(list);
      });
    }
  }, [code]);

  useEffect(() => {
    if (walkinStatus && walkinStatus.status === 1) {
      setWalkinDrive(walkinStatus?.data?.isWalkInDrive);
    }
  }, [walkinStatus]);

  const handleEducationDetails = (e, index, name) => {
    const eduValues = [...educationDetails];
    eduValues[index][name] = e;
    let today = new Date();
    if (name === "pursuing" && e === true) {
      eduValues[index]["to"] = moment(today).format("MM/yyyy");
    }
    setEducationDetails(eduValues);
  };

  const handleReupload = () => {
    setFile();
    setPreview("");
    setFileList([]);
    setFileType("");
    setErrors({
      ...errors,
      succsessFile: "",
      file: "",
    });

    setSelectedSkill([]);
    let deletePayload = {
      type: "resume",
      filePath: consultantData.resume,
    };
    dispatch(candidateFileDelete(deletePayload));
    setConsultantData({
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      phoneCode: { label: "+91", value: "+91" },
      noticePeriod: "",
      currentEmployer: "",
      totalExperiance: "",
      currentSalary: "",
      skillSet: [],
      educationalDetails: [],
      experienceDetails: [],
      faceBook: "",
      linkdin: "",
      summary: "",
      street: "",
      zipCode: "",
      city: "",
      state: "",
      country: "",
      resume: "",
      qualificationId: "",
      qualification: "",
      photo: consultantData.photo,
    });
  };

  const handleExpDetail = (e, index, name) => {
    const expValues = [...experienceDetails];
    expValues[index][name] = e;
    let today = new Date();
    if (name === "isWorking" && e === true) {
      expValues[index]["to"] = moment(today).format("MM/yyyy");
    }
    setExperienceDetails(expValues);
  };

  const handleAddEducation = (e) => {
    e.preventDefault();
    setEducationDetails([
      {
        institute: "",
        major: "",
        degree: "",
        from: "",
        to: "",
        pursuing: false,
      },
      ...educationDetails,
    ]);
  };

  const handleExeperienceAdd = (e) => {
    e.preventDefault();
    setExperienceDetails([
      {
        occupation: "",
        company: "",
        summary: "",
        from: "",
        to: "",
        isWorking: false,
      },
      ...experienceDetails,
    ]);
  };

  const handleRemoveEducation = (index) => {
    const educationValues = [...educationDetails];
    let obj = educationDetails[index];
    delete obj["institute"];
    delete obj["degree"];
    delete obj["from"];
    delete obj["to"];
    delete obj["major"];
    delete obj["pursuing"];
    educationValues.splice(index, 1);
    setEducationDetails(educationValues);
  };

  const handleRemoveExperience = (index) => {
    const experienceValues = [...experienceDetails];
    let obj = experienceDetails[index];
    delete obj["company"];
    delete obj["from"];
    delete obj["isWorking"];
    delete obj["occupation"];
    delete obj["summary"];
    delete obj["to"];
    experienceValues.splice(index, 1);
    setExperienceDetails(experienceValues);
  };
  const userData = getParsedItem("userInfo");
  const logoutHandler = () => {
    // localStorage.clear();
    removeItem("accessToken");
    removeItem("userInfo");
    history.push("/");
    showSuccessToast("Logout Successfully");
  };

  // Last 10 digits, so "+91 98765-43210" becomes "9876543210"
  const normalizePhone = (value) => {
    const digits = String(value || "").replace(/\D/g, "");
    return digits.length > 10 ? digits.slice(-10) : digits;
  };

  // Long degree names mapped to the short forms the qualification list uses
  const degreeAliases = [
    [/bachelor of technology/, "btech"],
    [/bachelor of engineering/, "be"],
    [/bachelor of computer applications?/, "bca"],
    [/bachelor of business administration/, "bba"],
    [/bachelor of science/, "bsc"],
    [/bachelor of commerce/, "bcom"],
    [/bachelor of arts/, "ba"],
    [/master of technology/, "mtech"],
    [/master of engineering/, "me"],
    [/master of computer applications?/, "mca"],
    [/master of business administration/, "mba"],
    [/master of science/, "msc"],
    [/master of commerce/, "mcom"],
    [/master of arts/, "ma"],
    [/doctor of philosophy/, "phd"],
    [/higher secondary|\bhsc\b|\b12th\b/, "hsc 12th"],
    [/secondary school|\bssc\b|\b10th\b/, "ssc 10th"],
  ];

  // "B.Tech (CSE)" -> ["btech", "cse"], plus alias tokens for long names
  const degreeTokens = (text) => {
    let value = String(text || "").toLowerCase();
    degreeAliases.forEach(([pattern, alias]) => {
      if (pattern.test(value)) value += ` ${alias}`;
    });
    return value.replace(/\./g, "").split(/[^a-z0-9]+/).filter(Boolean);
  };

  // Higher number = higher degree, so we can pick the highest one held
  const degreeRank = (tokens) => {
    const text = ` ${tokens.join(" ")} `;
    if (/ (phd|doctorate) /.test(text)) return 6;
    if (/ (mtech|me|mca|mba|msc|mcom|ma|master|masters|pg|pgdm|postgraduate) /.test(text)) return 5;
    if (/ (btech|be|bca|bba|bsc|bcom|ba|bachelor|bachelors|graduate|graduation) /.test(text)) return 4;
    if (/ diploma /.test(text)) return 3;
    if (/ (hsc|12th) /.test(text)) return 2;
    if (/ (ssc|10th) /.test(text)) return 1;
    return 0;
  };

  // True when every token of the list item appears in order inside the degree
  const containsTokens = (haystack, needle) =>
    needle.length > 0 &&
    haystack.some((_, start) =>
      needle.every((token, i) => haystack[start + i] === token)
    );

  // Tokens for a dropdown option, e.g. "B.E Graduate" -> [be], "M C A" -> [mca]
  const optionTokens = (text) => {
    let tokens = degreeTokens(text).filter(
      (token) => !["graduate", "graduation", "degree"].includes(token)
    );
    // "M C A" / "B Com" / "M Tech" are spaced-out abbreviations: join them
    if (tokens.length > 1 && tokens[0].length === 1) {
      tokens = [tokens.join("")];
    }
    return tokens;
  };

  const matchQualification = (educations) => {
    const options = qualificationDetail?.data || [];
    if (!options.length || !Array.isArray(educations)) return null;

    const degrees = educations
      .map((edu) => degreeTokens(`${edu?.degree || ""} ${edu?.major || ""}`))
      .filter((tokens) => tokens.length)
      .sort((a, b) => degreeRank(b) - degreeRank(a));

    for (const degree of degrees) {
      // Prefer the most specific list item, e.g. "M.Sc IT" over "M.Sc"
      const best = options
        .map((option) => ({
          option,
          tokens: optionTokens(option.qualification),
        }))
        .filter(
          ({ tokens }) =>
            tokens.length > 0 &&
            tokens[0] !== "other" &&
            containsTokens(degree, tokens)
        )
        .sort((a, b) => b.tokens.length - a.tokens.length)[0];
      if (best) {
        return { label: best.option.qualification, value: best.option._id };
      }
    }

    // Graduate-level degree with no exact entry: use the catch-all option
    if (degrees.length && degreeRank(degrees[0]) >= 4) {
      const other = options.find(
        (option) => String(option.qualification).toLowerCase() === "other graduate"
      );
      if (other) return { label: other.qualification, value: other._id };
    }
    return null;
  };

  const addResume = async (resume, mode = "all") => {
    let type = resume.name.split(".").pop().toLowerCase();
    setFileType(type);
    if (type === "pdf") {
      const objectUrl = URL.createObjectURL(resume);
      setPreview(objectUrl);
    }
    setFile(resume);

    if (mode === "only") {
      // Swap just the resume file; the form data stays as it was
      setReplacingResume(true);
      if (consultantData.resume) {
        dispatch(
          candidateFileDelete({ type: "resume", filePath: consultantData.resume })
        );
      }
      let replacePayload = new FormData();
      replacePayload.append("file", resume);
      replacePayload.append("type", "resume");
      const replaceRes = await dispatch(candidateFileUpload(replacePayload));
      setConsultantData((prev) => ({
        ...prev,
        resume: replaceRes?.data?.data?.response,
      }));
      setReplacingResume(false);
      showSuccessToast("Resume updated.");
      return;
    }

    setParsingResume(true);

    let parsed = {};
    let formData = new FormData();
    formData.append("file", resume);
    const res = await dispatch(addCvDetails(formData));
    const cv = res?.data?.status === 1 ? res?.data?.data : null;

    if (cv) {
      const skills = (cv.candidateSkillSet || []).filter((item) => item._id);
      setSelectedSkill(
        skills.map((item) => ({ value: item._id, label: item.skill }))
      );

      const city = (cv.currentLocation || "").split(",")[0].trim();
      parsed = {
        firstName: cv.firstName || "",
        lastName: cv.lastName || "",
        email: cv.emailId || "",
        mobile: normalizePhone(cv.mobile || cv.phone),
        currentEmployer: cv.currentEmployer || "",
        totalExperiance:
          Number(cv.totalExperiance) > 0 ? String(cv.totalExperiance) : "",
        city,
        skillSet: skills.map((item) => item._id),
      };
      const qualification = matchQualification(cv.educations);
      if (qualification) {
        parsed.qualificationId = qualification;
        parsed.qualification = qualification;
      }
      // Drop anything the parser couldn't find so typed values survive
      Object.keys(parsed).forEach((key) => {
        const value = parsed[key];
        if (value === "" || (Array.isArray(value) && value.length === 0)) {
          delete parsed[key];
        }
      });

      setErrors((prev) => {
        const next = { ...prev };
        Object.keys(parsed).forEach((key) => {
          next[key] = "";
        });
        return next;
      });
    }

    let payload = new FormData();
    payload.append("file", resume);
    payload.append("type", "resume");
    const uploadRes = await dispatch(candidateFileUpload(payload));

    setConsultantData((prev) => ({
      ...prev,
      ...parsed,
      resume: uploadRes?.data?.data?.response,
    }));
    setParsingResume(false);

    if (cv && Object.keys(parsed).length > 0) {
      showSuccessToast("Details filled from resume. Please review them.");
    } else {
      showErrorToast(
        "We couldn't read details from this resume. Please fill them in."
      );
    }
  };

  const fileTypes = [
    "PDF",
    "DOC",
    "DOCX",
    "JPG",
    "JPEG",
    "PNG",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  var noticePeriod = [
    "Immediately",
    "15 Days",
    "30 Days",
    "45 Days",
    "60 Days",
  ].map(function (notperiod) {
    return { label: notperiod, value: notperiod };
  });

  // const getWalkInDriveList = (searchText) => {
  //   clearTimeout(timeOut.current);
  //   timeOut.current = setTimeout(async () => {
  //     if (searchText !== "") {
  //       await dispatch(getWalkInDriveDetails(searchText));
  //     } else {
  //       setWalkinDriveSourceOption(null);
  //     }
  //   }, 600);
  // };

  const getSkillSetList = (searchText) => {
    clearTimeout(timeOut.current);
    timeOut.current = setTimeout(async () => {
      if (searchText !== "") {
        await dispatch(getSkillDetails(searchText));
      } else {
        setSkillSetOption(null);
      }
    }, 600);
  };

  const handleChange = async (file) => {
    if (file) {
      setErrors({
        ...errors,
        succsessFile: "",
        file: "",
      });
    }
    setFile(file);
    let formData = new FormData();
    formData.append("file", file);
    await dispatch(addCvDetails(formData));
  };

  const addProfile = async (profile) => {
    let payload = new FormData();
    payload.append("file", profile);
    payload.append("type", "photo");
    dispatch(candidateFileUpload(payload)).then((res) => {
      setConsultantData({
        ...consultantData,
        photo: res?.data?.data?.response,
      });
    });
  };

  const handleDataChange = (e, type) => {
    if (type === "num") {
      setConsultantData({ ...consultantData, [e.target.name]: e.target.value });
    } else if (type === "email") {
      setConsultantData({
        ...consultantData,
        [e.target.name]: emailValidator(e.target.value),
      });
    } else {
      setConsultantData({
        ...consultantData,
        [e.target.name]: textValidator(e.target.value),
      });
    }
  };

  const getSrcFromFile = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.originFileObj);
      reader.onload = () => resolve(reader.result);
    });
  };

  const onResumeChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    if (newFileList.length > 0) {
      setErrors({
        ...errors,
        succsessFile: "",
        file: "",
      });

      // let type = newFileList[0].originFileObj.name.split(".")[1];
      // setFileType(type);
      // if (type === "pdf") {
      //   const objectUrl = URL.createObjectURL(newFileList[0].originFileObj);
      //   setPreview(objectUrl);
      // }
      //   setFile(newFileList[0].originFileObj);

      //   let formData = new FormData();
      //   formData.append("file", newFileList[0].originFileObj);
      //   await dispatch(addCvDetails(formData));
      //   let payload = new FormData();
      //   payload.append("file", newFileList[0].originFileObj);
      //   payload.append("type", "resume");
      //   // dispatch(candidateFileUpload(payload)).then((res) => {
      //   //   setConsultantData({
      //   //     ...consultantData,
      //   //     resume: res?.data?.data?.response,
      //   //   });
      //   // });
    }
  };

  const handleImageChange = async ({ fileList: newFileList }) => {
    if (newFileList.length > 0) {
      setProfileList(newFileList);
      setErrors({
        ...errors,
        successImageFile: "",
        file: "",
      });
    }
    setImage(newFileList[0].originFileObj);

    // let payload = new FormData();
    // payload.append("file", newFileList[0].originFileObj);
    // payload.append("type", "photo");
    // dispatch(candidateFileUpload(payload)).then((res) => {
    //   setJobApplicationData({
    //     ...jobApplicationData,
    //     photo: res?.data?.data?.response,
    //   });
    // });
  };

  const handleImageReupload = () => {
    setImage();
    // setPreview("");
    setProfileList([]);
    // setFileType("");
    setErrors({
      ...errors,
      successImageFile: "",
      // file: "",
    });

    let payload = {
      type: "photo",
      filePath: consultantData.photo,
    };
    dispatch(candidateFileDelete(payload));
    setConsultantData({
      ...consultantData,
      photo: "",
    });
  };

  const onPreview = async (file) => {
    const src = file.url || (await getSrcFromFile(file));
    const imgWindow = window.open(src);

    if (imgWindow) {
      const image = new Image();
      image.src = src;
      imgWindow.document.write(image.outerHTML);
    } else {
      window.location.href = src;
    }
  };

  const validateForm = (stepFields) => {
    let isFormValid = true;
    let error = {
      firstName: "",
      phoneCode: "",
      lastName: "",
      email: "",
      mobile: "",
      currentEmployer: "",
      totalExperiance: "",
      currentSalary: "",
      city: "",
      qualification: "",
    };
    let mobileRegex = "^[0-9][0-9]{9,12}$";
    let emailRegex =
      /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (consultantData.firstName === "") {
      error.firstName = "First Name is required";
    } else error.firstName = "";

    if (consultantData.lastName === "") {
      error.lastName = "Last Name is required";
    } else error.lastName = "";

    if (consultantData.email === "") {
      error.email = "Email is required";
    } else if (!new RegExp(emailRegex).test(consultantData.email)) {
      error.email = "Please provide a valid email";
    } else error.email = "";

    if (consultantData.phoneCode === "") {
      error.phoneCode = "Phone Code is required";
    } else error.phoneCode = "";

    if (consultantData.mobile === "") {
      error.mobile = "Mobile is required";
    } else if (!new RegExp(mobileRegex).test(consultantData.mobile)) {
      error.mobile = "Mobile number in between 10-13 digits";
    } else error.mobile = "";

    if (consultantData.currentEmployer === "") {
      error.currentEmployer = "This field is required.";
    } else error.currentEmployer = "";

    if (consultantData.totalExperiance === "") {
      error.totalExperiance = "This field is required.";
    } else error.totalExperiance = "";

    if (consultantData.currentSalary === "") {
      error.currentSalary = "This field is required.";
    } else error.currentSalary = "";

    if (consultantData.city === "") {
      error.city = "This field is required.";
    } else error.city = "";

    if (consultantData.qualificationId === "") {
      error.qualification = "This field is required";
    } else error.qualification = "";

    if (file === undefined) {
      error.file = "Please upload resume";
    } else error.file = "";

    if (
      error.firstName !== "" ||
      error.lastName !== "" ||
      error.email !== "" ||
      error.phoneCode !== "" ||
      error.mobile !== "" ||
      error.currentEmployer !== "" ||
      error.totalExperiance !== "" ||
      error.currentSalary !== "" ||
      error.qualification !== "" ||
      error.city !== "" ||
      error.file !== ""
    ) {
      isFormValid = false;
    } else {
      isFormValid = true;
    }
    if (stepFields) {
      // Wizard step: only surface (and check) the fields on that step
      const scoped = {};
      stepFields.forEach((field) => {
        scoped[field] = error[field] || "";
      });
      setErrors((prev) => ({ ...prev, ...scoped }));
      return stepFields.every((field) => !error[field]);
    }
    setErrors(error);
    return isFormValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (activeStep < formSteps.length - 1) {
      handleNext();
      return;
    }
    // Send the user back to the first step that still has a problem
    for (let i = 0; i < formSteps.length; i++) {
      if (!validateForm(formSteps[i].fields)) {
        setActiveStep(i);
        focusFirstError();
        return;
      }
    }
    if (!validateForm()) {
      focusFirstError();
      return;
    }
    if (validateForm()) {
      setIsLoading(true);

      let list = [];
      consultantData.skillSet.map((item) => list.push(item.value));

      let obj = {
        // postingTitle: [jobData._id],
        firstName: consultantData.firstName,
        lastName: consultantData.lastName,
        emailId: consultantData.email,
        phoneCode: consultantData.phoneCode.value,
        mobile: consultantData.mobile,
        noticePeriod: consultantData.noticePeriod.value,
        currentEmployer: consultantData.currentEmployer,
        totalExperiance: consultantData.totalExperiance,
        currentSalary: consultantData.currentSalary,
        skillSet: consultantData.skillSet,
        ...(educationDetails.length > 0 && {
          educations: educationDetails,
        }),
        ...(experienceDetails.length > 0 && {
          experiences: experienceDetails,
        }),
        street: consultantData.street,
        zipCode: consultantData.zipCode,
        city: consultantData.city,
        state: consultantData.state,
        country: consultantData.country,
        faceBook: consultantData.faceBook,
        linkdin: consultantData.linkdin,
        qualification: consultantData.qualificationId.value,
        ...(consultantData.walkinDriveSourceId !== "" && {
          walkinDriveSource: consultantData.walkinDriveSourceId.value,
        }),
        resume: "resume",
        consultant: getParsedItem("userInfo")?.companyId?._id,
        source: getParsedItem("userInfo")?._id,
        createdFrom: "consultant",
      };
      dispatch(addCandidateData(obj));
    }
  };

  const resetData = () => {
    setConsultantData({
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      phoneCode: { label: "+91", value: "+91" },
      noticePeriod: "",
      currentEmployer: "",
      totalExperiance: "",
      currentSalary: "",
      skillSet: [],
      educationalDetails: [],
      experienceDetails: [],
      faceBook: "",
      linkdin: "",
      summary: "",
      street: "",
      zipCode: "",
      city: "",
      state: "",
      country: "",
      referrerName: "",
      referrerEmail: "",
      relation: "",
      knownPeriod: "",
      qualificationId: "",
      qualification: "",
      walkinDriveSourceId: "",
      walkinDriveSource: "",
    });
    setSelectedSkill([]);
    setErrors({
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      phoneCode: "",
      noticePeriod: "",
      currentEmployer: "",
      totalExperiance: "",
      currentSalary: "",
      skillSet: "",
      educationalDetails: [],
      experienceDetails: [],
      faceBook: "",
      linkdin: "",
      summary: "",
      street: "",
      zipCode: "",
      city: "",
      state: "",
      country: "",
      referrerName: "",
      referrerEmail: "",
      relation: "",
      knownPeriod: "",
      qualificationId: "",
      qualification: "",
    });
    setShow(false);
    setEducationDetails([
      {
        institute: "",
        major: "",
        degree: "",
        from: "",
        to: "",
        pursuing: false,
      },
    ]);
    setExperienceDetails([
      {
        occupation: "",
        company: "",
        summary: "",
        from: "",
        to: "",
        isWorking: false,
      },
    ]);
  };

  const handleClose = () => {
    setShow(false);
  };

  // Wizard steps; `fields` are the error keys validated before moving on,
  // `done` ticks the step once everything on it is filled
  const filled = (value) =>
    Array.isArray(value) ? value.length > 0 : !!value && value !== "";
  const formSteps = [
    { id: "nic-upload", label: "Upload documents", fields: ["file"], done: !!file },
    {
      id: "nic-basic",
      label: "Basic info",
      fields: ["firstName", "lastName", "email", "phoneCode", "mobile"],
      done: ["firstName", "lastName", "email", "phoneCode", "mobile"].every(
        (key) => filled(consultantData[key])
      ),
    },
    {
      id: "nic-professional",
      label: "Professional details",
      fields: [
        "currentEmployer",
        "totalExperiance",
        "currentSalary",
        "qualification",
      ],
      done: [
        "currentEmployer",
        "totalExperiance",
        "currentSalary",
        "qualificationId",
      ].every((key) => filled(consultantData[key])),
    },
    {
      id: "nic-address",
      label: "Address details",
      fields: ["city"],
      done: filled(consultantData.city),
    },
  ];

  const goToStep = (index) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setActiveStep(index);
  };

  // After errors render, scroll to the first visible invalid field and focus it
  const focusFirstError = () => {
    setTimeout(() => {
      const el = Array.from(
        document.querySelectorAll(".nic-cform .error-red")
      ).find((node) => node.offsetParent !== null);
      if (!el) return;
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      const input = el.matches("input, textarea")
        ? el
        : el.querySelector("input, textarea");
      input && input.focus({ preventScroll: true });
    }, 150);
  };

  const handleNext = () => {
    if (validateForm(formSteps[activeStep].fields)) {
      goToStep(activeStep + 1);
    } else {
      focusFirstError();
    }
  };

  const handleBack = () => goToStep(activeStep - 1);

  // Convert the uploaded .docx to HTML for the preview modal
  useEffect(() => {
    if (!showDocPreview || !file || !docPreviewRef.current) return;
    docPreviewRef.current.innerHTML = "";
    file
      .arrayBuffer()
      .then((arrayBuffer) => mammoth.convertToHtml({ arrayBuffer }))
      .then((result) => {
        if (docPreviewRef.current) {
          docPreviewRef.current.innerHTML = result.value;
        }
      })
      .catch(() => {
        showErrorToast("Unable to preview this document.");
        setShowDocPreview(false);
      });
  }, [showDocPreview]);

  const handlePreviewResume = () => {
    if (fileType === "pdf") {
      preview && window.open(preview, "_blank");
    } else if (fileType === "docx") {
      setShowDocPreview(true);
    } else if (file) {
      // Browsers cannot render legacy .doc files, so open them in the user's app
      const url = URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = url;
      link.download = file.name;
      link.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
  };

  // Close the Capture / Upload menu on any outside click
  useEffect(() => {
    if (!avatarMenu) return undefined;
    const close = () => setAvatarMenu(false);
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, [avatarMenu]);

  // The antd Upload keeps a hidden file input; drive it from our own menu
  const getAvatarInput = () =>
    avatarBlock.current && avatarBlock.current.querySelector("input[type=file]");

  const handleAvatarUpload = () => {
    setAvatarMenu(false);
    const input = getAvatarInput();
    input && input.click();
  };

  const stopCamera = () => {
    streamRef.current &&
      streamRef.current.getTracks().forEach((track) => track.stop());
    streamRef.current = null;
  };

  const handleAvatarCapture = async () => {
    setAvatarMenu(false);
    try {
      streamRef.current = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "user" },
      });
      setShowCamera(true);
    } catch (err) {
      showErrorToast("Unable to access the camera. Please allow camera access.");
    }
  };

  const closeCamera = () => {
    stopCamera();
    setShowCamera(false);
  };

  const takePhoto = () => {
    const video = videoRef.current;
    if (!video || !video.videoWidth) return;
    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext("2d").drawImage(video, 0, 0);
    canvas.toBlob(
      (blob) => {
        if (!blob) return;
        const photo = new File([blob], "profile-picture.jpg", {
          type: "image/jpeg",
        });
        closeCamera();
        // Hand the photo to the same Upload (and crop) flow as a picked file
        const input = getAvatarInput();
        if (input) {
          const transfer = new DataTransfer();
          transfer.items.add(photo);
          input.files = transfer.files;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      },
      "image/jpeg",
      0.92
    );
  };

  const chooseReplaceMode = (mode) => {
    replaceMode.current = mode;
    setShowReplace(false);
    replaceInput.current && replaceInput.current.click();
  };

  const onReplaceFileSelected = (e) => {
    const resume = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!resume) return;
    const ext = resume.name.split(".").pop().toLowerCase();
    if (!["pdf", "doc", "docx"].includes(ext)) {
      showErrorToast("Please upload a PDF, DOC or DOCX file.");
      return;
    }
    addResume(resume, replaceMode.current);
  };

  // Once a resume is uploaded every step can be opened directly; the
  // required fields are still checked on Next and on Submit
  const handleStepClick = (index) => goToStep(index);

  return (
    <React.Fragment>
      {/* <Container>
        <Row className="justify-content-md-center">
          <Col xl="10">
            <div className="btn-logout-webform">
              <span className="font-weight-bold">
                Hii, {userData && userData.firstName + " " + userData.lastName}
              </span>
              <Button variant="danger" onClick={logoutHandler} className="ml-3">
                <span className="bx bx-log-out"></span> LOGOUT
              </Button>
            </div>
          </Col>
        </Row>
      </Container> */}

      {/* <div className="consultant-header-new">
        <Container>
          <Row className="justify-content-md-center">
            <Col xl="12">
            <div className="panel">
              <div className="panel-header">
                <h2 className="display-4 font-weight-semibold">
                  {userData && userData.companyId && userData.companyId.name}
                </h2>
              </div>
            </div>
            </Col>
          </Row>
        </Container>
      </div> */}

      <div className="nic-cform-page">
      <div className="nic-cform">
        <main className={`nic-main${uploadMode === "bulk" ? " is-bulk" : ""}`}>
        {/* Start: Banner */}
        <div className="nic-banner">
          <Image src={IndianicLogo} alt="IndiaNIC" className="nic-banner-logo" />
          <div className="nic-banner-text">
            <h2 className="nic-banner-title">Your next opportunity awaits</h2>
            <p>
              Fill in the candidate's details and let us know why they're a
              great fit for the team.
            </p>
          </div>
        </div>
        {/* Ends: Banner */}


        {/* Start: Header */}
        <div className="nic-topbar">
          <div>
            {userData && userData.companyId && userData.companyId.name && (
              <span className="nic-eyebrow">{userData.companyId.name}</span>
            )}
            <h1 className="nic-page-title">
              {uploadMode === "bulk"
                ? "Import candidates"
                : "Add candidate's profile details"}
            </h1>
          </div>

          <div className="nic-user">
            <button
              type="button"
              className={`nic-import-btn${uploadMode === "bulk" ? " is-active" : ""}`}
              aria-pressed={uploadMode === "bulk"}
              onClick={() => setUploadMode(uploadMode === "bulk" ? "single" : "bulk")}
            >
              <span className="bx bx-import" aria-hidden="true"></span>
              {uploadMode === "bulk" ? "Single candidate" : "Import candidates"}
            </button>
            <span
              className="nic-user-avatar"
              title={userData && userData.firstName + " " + userData.lastName}
            >
              <span className="bx bx-user"></span>
            </span>
            <button
              type="button"
              className="nic-user-logout"
              onClick={logoutHandler}
              title="Logout"
            >
              <span className="bx bx-log-out"></span>
            </button>
          </div>
        </div>
        {/* Ends: Header */}

        {uploadMode === "bulk" && (
          <BulkImport
            onViewCandidates={() => history.push("/web-form")}
          />
        )}
        <div className={uploadMode === "bulk" ? "d-none" : ""}>
        {/* Start: Stepper */}
        <ol className="nic-stepper">
          {formSteps.map((step, index) => (
            <li
              key={step.id}
              className={`nic-stepper-item ${
                index === activeStep ? "is-active" : ""
              } ${step.done ? "is-done" : ""} ${
                index > 0 && !file ? "is-locked" : ""
              }`}
            >
              <button
                type="button"
                className="nic-stepper-btn"
                disabled={index > 0 && !file}
                onClick={() => handleStepClick(index)}
              >
                <span className="nic-stepper-badge">
                  {parsingResume && index > 0 ? (
                    <span className="nic-stepper-spinner"></span>
                  ) : step.done && index > 0 ? (
                    <span className="bx bx-check"></span>
                  ) : (
                    index + 1
                  )}
                </span>
                <span className="nic-stepper-label">{step.label}</span>
              </button>
            </li>
          ))}
        </ol>
        {/* Ends: Stepper */}

        {/* Start: Form */}
        <section className="consultant-add-form">
          <div className="consultant-add-form-body">
            <Row>
              <Col lg="12">
                <aside
                  className={`doc-upload-block autofill-upload ${
                    activeStep === 0 ? "" : "d-none"
                  }`}
                  id="nic-upload"
                >
                  <h4 className="nic-section-title">
                    <span className="nic-section-badge">
                      <span className="bx bx-upload"></span>
                    </span>
                    Upload Documents
                  </h4>

                  <div className="autofill-upload-row">
                    <div className="autofill-upload-resume">
                      {/* File Uploader */}
                      <div className="document-file-uploader">
                        <div className="document-upload">
                          <div className="document-uploader-block">
                            {!file && (
                              <>
                                <div className="file-uploader-block">
                                  <div className="upload-icon-title">
                                    {/* <span className="bx bx-cloud-upload"></span> */}
                                    <span className="nic-upload-icon">
                                      <span className="bx bx-upload"></span>
                                    </span>
                                    <p className="upload-icon-title-text">
                                      Drag &amp; drop resume here
                                      <span className="text-danger">&nbsp;*</span>
                                    </p>
                                    <span className="nic-upload-or">or</span>
                                    <Button type="button" variant="dark">
                                      Browse File
                                    </Button>
                                    <span className="nic-upload-types">
                                      PDF, DOC, DOCX
                                    </span>
                                  </div>
                                </div>
                                <Upload
                                  listType="picture-card"
                                  fileList={fileList}
                                  onChange={onResumeChange}
                                  customRequest={({
                                    file: resume,
                                    onSuccess,
                                    onError,
                                  }) => {
                                    Promise.resolve().then(() => {
                                      if (resume.name.split(".")[1] !== "pdf") {
                                        onSuccess();
                                        addResume(resume);
                                      } else {
                                        addResume(resume);
                                      }
                                    });
                                  }}
                                  // onPreview={onPreview}
                                  accept=".pdf,.doc,.docx"
                                  onRemove={() => {
                                    setFile();
                                    setPreview("");
                                    setFileList([]);
                                    setFileType("");
                                    setErrors({
                                      ...errors,
                                      succsessFile: "",
                                      file: "",
                                    });
                                  }}
                                >
                                  {fileList.length < 1}
                                </Upload>{" "}
                              </>
                            )}
                            {file && (
                              <div className="nic-file-chip-box">
                              <div className="nic-file-chip">
                                <svg
                                  className="nic-file-chip-icon"
                                  viewBox="0 0 24 30"
                                  width="24"
                                  height="30"
                                  aria-hidden="true"
                                >
                                  <path
                                    d="M3 0h12l9 9v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z"
                                    fill={fileType === "pdf" ? "#E5252A" : "#2B6CD9"}
                                  />
                                  <path d="M15 0l9 9h-6a3 3 0 0 1-3-3z" fill="#fff" opacity=".45" />
                                  <text
                                    x="12"
                                    y="23"
                                    textAnchor="middle"
                                    fontSize="7"
                                    fontWeight="700"
                                    fontFamily="Arial, sans-serif"
                                    fill="#fff"
                                  >
                                    {fileType === "pdf" ? "PDF" : "DOC"}
                                  </text>
                                </svg>
                                <span className="nic-file-chip-info">
                                  <span
                                    className="nic-file-chip-name"
                                    title={file.name}
                                  >
                                    {file.name}
                                  </span>
                                  <small>
                                    {(file.size / 1024).toFixed(1)} KB
                                  </small>
                                </span>
                                <button
                                  type="button"
                                  title="Preview"
                                  onClick={handlePreviewResume}
                                >
                                  <span className="bx bx-show"></span>
                                </button>
                                <button
                                  type="button"
                                  title="Replace"
                                  onClick={() => setShowReplace(true)}
                                >
                                  <span className="bx bx-pencil"></span>
                                </button>
                                <button
                                  type="button"
                                  title="Remove"
                                  onClick={handleReupload}
                                >
                                  <span className="bx bx-x"></span>
                                </button>
                              </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <small style={{ color: "red" }}>{errors.file}</small>
                        <small style={{ color: "green" }}>
                          {errors.succsessFile}
                        </small>
                      </div>
                      {/* File Uploader */}
                    </div>
                    <div className="autofill-upload-avatar">
                      {/* Begin: Attach Image */}
                      <div
                        className="document-file-uploader upload-img"
                        title="Upload profile picture (JPG, PNG, JPEG)"
                      >
                        <div className="document-upload">
                          {profileList && (
                            <>
                              <div className="position-relative">
                                <div
                                  className="document-uploader-block"
                                  ref={avatarBlock}
                                >
                                  <button
                                    type="button"
                                    className="nic-avatar-trigger"
                                    aria-label="Profile picture options"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setAvatarMenu((open) => !open);
                                    }}
                                  ></button>
                                  {avatarMenu && (
                                    <div className="nic-avatar-menu">
                                      {image && (
                                        <button
                                          type="button"
                                          onClick={() => {
                                            setAvatarMenu(false);
                                            profileList[0] &&
                                              onPreview(profileList[0]);
                                          }}
                                        >
                                          <span className="bx bx-show"></span>
                                          Preview
                                        </button>
                                      )}
                                      <button
                                        type="button"
                                        onClick={handleAvatarUpload}
                                      >
                                        <span className="bx bx-upload"></span>
                                        {image ? "Upload new" : "Upload"}
                                      </button>
                                      <button
                                        type="button"
                                        onClick={handleAvatarCapture}
                                      >
                                        <span className="bx bx-camera"></span>
                                        Capture
                                      </button>
                                      {image && (
                                        <>
                                          <hr />
                                          <button
                                            type="button"
                                            className="is-danger"
                                            onClick={() => {
                                              setAvatarMenu(false);
                                              handleImageReupload();
                                            }}
                                          >
                                            <span className="bx bx-trash"></span>
                                            Remove
                                          </button>
                                        </>
                                      )}
                                    </div>
                                  )}
                                  <div className="upload-icon-title">
                                    {/* <span className="bx bx-cloud-upload"></span> */}
                                    <span className="bx bx-user"></span>
                                  </div>
                                  <span
                                    className="nic-avatar-camera"
                                    aria-hidden="true"
                                  >
                                    <span
                                      className={`bx ${
                                        image ? "bx-check" : "bxs-camera"
                                      }`}
                                    ></span>
                                  </span>
                                  <ImgCrop grid rotate>
                                    <Upload
                                      listType="picture-card"
                                      fileList={profileList}
                                      maxCount={1}
                                      onChange={(e) => handleImageChange(e)}
                                      customRequest={({
                                        file,
                                        onSuccess,
                                        onError,
                                      }) => {
                                        Promise.resolve().then(() => {
                                          onSuccess();
                                          addProfile(file);
                                        });
                                      }}
                                      onPreview={onPreview}
                                      onRemove={() => {
                                        setProfileList([]);
                                        setImage();
                                        setErrors({
                                          ...errors,
                                          successImageFile: "",
                                        });
                                      }}
                                    >
                                      {profileList.length < 1}
                                    </Upload>
                                  </ImgCrop>
                                </div>
                                <p className="autofill-upload-avatar-label">
                                  Profile picture
                                </p>
                                <div className="text-center">
                                  <small style={{ color: "green" }}>
                                    {errors.successImageFile}
                                  </small>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {/* Ends: Attach Image */}
                    </div>
                  </div>
                </aside>
              </Col>
              <Col lg="12">
                {/* Form Fields Begins */}
                <Form onSubmit={handleSubmit}>
                  <div className="panel">
                    {/* Begin: Basic Info */}
                    <div className={activeStep === 1 ? "" : "d-none"}>
                    <div className="panel-header" id="nic-basic">
                      <h4 className="nic-section-title">
                        <span className="nic-section-badge">2</span>
                        Basic Info
                      </h4>
                    </div>

                    <div className="panel-content py-0">
                      <Row>
                        <Col lg="4" md="6">
                          <Form.Group controlId="formFirstName">
                            <Form.Label>
                              First Name
                              <span className="text-danger">&nbsp;*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="firstName"
                              maxLength="20"
                              disabled={!file}
                              className={
                                errors.firstName !== ""
                                  ? "error-red"
                                  : !file
                                  ? "disabled-field"
                                  : ""
                              }
                              value={consultantData.firstName}
                              onChange={(e) => {
                                handleDataChange(e);
                                setErrors({
                                  ...errors,
                                  firstName: "",
                                });
                              }}
                            />
                            <span
                              className="error-msg"
                              style={{ color: "red" }}
                            >
                              {errors.firstName}
                            </span>
                          </Form.Group>
                        </Col>
                        <Col lg="4" md="6">
                          <Form.Group controlId="formLastName">
                            <Form.Label>
                              Last Name
                              <span className="text-danger">&nbsp;*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="lastName"
                              maxLength="20"
                              disabled={!file}
                              className={
                                errors.lastName !== ""
                                  ? "error-red"
                                  : !file
                                  ? "disabled-field"
                                  : ""
                              }
                              value={consultantData.lastName}
                              onChange={(e) => {
                                handleDataChange(e);
                                setErrors({
                                  ...errors,
                                  lastName: "",
                                });
                              }}
                            />
                            <span
                              className="error-msg"
                              style={{ color: "red" }}
                            >
                              {errors.lastName}
                            </span>
                          </Form.Group>
                        </Col>
                        <Col lg="4" md="6">
                          <Form.Group controlId="formEmail">
                            <Form.Label>
                              Email
                              <span className="text-danger">&nbsp;*</span>
                            </Form.Label>
                            <Form.Control
                              type="email"
                              name="email"
                              maxLength="45"
                              disabled={!file}
                              className={
                                errors.email !== ""
                                  ? "error-red"
                                  : !file
                                  ? "disabled-field"
                                  : ""
                              }
                              value={consultantData.email}
                              onChange={(e) => {
                                handleDataChange(e, "email");
                                setErrors({
                                  ...errors,
                                  email: "",
                                });
                              }}
                            />
                            <span
                              className="error-msg"
                              style={{ color: "red" }}
                            >
                              {errors.email}
                            </span>
                          </Form.Group>
                        </Col>
                        <Col lg="4" md="6">
                          <Form.Group controlId="formMobile">
                            <Form.Label>
                              Mobile
                              <span className="text-danger">&nbsp;*</span>
                            </Form.Label>
                            <PhoneInput
                              country="in"
                              specialLabel=""
                              disabled={!file}
                              value={`${String(
                                (consultantData.phoneCode &&
                                  consultantData.phoneCode.value) ||
                                  "+91"
                              ).replace(/\D/g, "")}${consultantData.mobile || ""}`}
                              containerClass="nic-phone"
                              inputClass={
                                errors.mobile !== "" ? "error-red" : ""
                              }
                              onChange={(value, country) => {
                                const dial = String(
                                  (country && country.dialCode) || "91"
                                );
                                setConsultantData({
                                  ...consultantData,
                                  phoneCode: {
                                    label: `+${dial}`,
                                    value: `+${dial}`,
                                  },
                                  mobile: value.slice(dial.length),
                                });
                                setErrors({
                                  ...errors,
                                  mobile: "",
                                  phoneCode: "",
                                });
                              }}
                            />
                            <span
                              className="error-msg"
                              style={{ color: "red" }}
                            >
                              {errors.mobile || errors.phoneCode}
                            </span>
                          </Form.Group>
                        </Col>
                        <Col lg="4" md="6">
                          <Form.Group controlId="formEmail">
                            <Form.Label>Notice Period</Form.Label>
                            <SimpleSelectComponent
                              options={noticePeriod}
                              name="noticePeriod"
                              value={consultantData.noticePeriod}
                              disabled={!file}
                              className={!file ? "disabled-field" : ""}
                              onValueChange={(e) => {
                                e &&
                                  setConsultantData({
                                    ...consultantData,
                                    noticePeriod: e,
                                  });
                              }}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                    </div>
                    {/* Ends: Basic Info */}

                    {/* Begin: Professional Details */}
                    <div className={activeStep === 2 ? "" : "d-none"}>
                    <div className="panel-header" id="nic-professional">
                      <h4 className="nic-section-title">
                        <span className="nic-section-badge">3</span>
                        Professional Details
                      </h4>
                    </div>

                    <div className="panel-content py-0">
                      <Row>
                        <Col lg="4" md="6">
                          <Form.Group controlId="formHighQualifHeld">
                            <Form.Label>
                              {" "}
                              Highest Qualification Held
                              <span className="text-danger">&nbsp;*</span>
                            </Form.Label>
                            <SimpleSelectComponent
                              name="qualification"
                              value={consultantData.qualification}
                              disabled={!file}
                              className={
                                errors.qualification
                                  ? "error-red"
                                  : !file
                                  ? "disabled-field"
                                  : ""
                              }
                              onValueChange={(e) => {
                                e &&
                                  setConsultantData({
                                    ...consultantData,
                                    qualificationId: e,
                                    qualification: e,
                                  });
                                setErrors({
                                  ...errors,
                                  qualification: "",
                                });
                              }}
                            >
                              {qualificationDetail?.data?.map((data) => (
                                <option value={data._id}>
                                  {data.qualification}
                                </option>
                              ))}
                            </SimpleSelectComponent>
                            <span
                              className="error-msg"
                              style={{ color: "red" }}
                            >
                              {errors.qualification}
                            </span>
                          </Form.Group>
                        </Col>
                        <Col lg="4" md="6">
                          <Form.Group controlId="formCurrentEmployer">
                            <Form.Label>
                              Current Employer
                              <span className="text-danger">&nbsp;*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="currentEmployer"
                              maxLength="30"
                              disabled={!file}
                              className={
                                errors.currentEmployer !== ""
                                  ? "error-red"
                                  : !file
                                  ? "disabled-field"
                                  : ""
                              }
                              value={consultantData.currentEmployer}
                              onChange={(e) => {
                                handleDataChange(e);
                                setErrors({
                                  ...errors,
                                  currentEmployer: "",
                                });
                              }}
                            />
                            <span
                              className="error-msg"
                              style={{ color: "red" }}
                            >
                              {errors.currentEmployer}
                            </span>
                          </Form.Group>
                        </Col>
                        <Col lg="4" md="6">
                          <Form.Group controlId="formtotalExperiance">
                            <Form.Label>
                              Total Experience(IN YEAR)
                              <span className="text-danger">&nbsp;*</span>
                            </Form.Label>
                            <Form.Control
                              type="number"
                              disabled={!file}
                              className={
                                errors.totalExperiance !== ""
                                  ? "error-red form-control"
                                  : !file
                                  ? "disabled-field form-control"
                                  : "form-control"
                              }
                              value={consultantData.totalExperiance}
                              onChange={(e) => {
                                setConsultantData({
                                  ...consultantData,
                                  totalExperiance: e.target.value,
                                });
                                setErrors({
                                  ...errors,
                                  totalExperiance: "",
                                });
                              }}
                              onKeyDown={(evt) =>
                                ["e", "E", "+", "-"].includes(evt.key) &&
                                evt.preventDefault()
                              }
                              onInput={(e) => {
                                if (e.target.value.length > e.target.maxLength)
                                  e.target.value = e.target.value.slice(
                                    0,
                                    e.target.maxLength
                                  );
                              }}
                              maxlength={5}
                            />
                            {/* <InputMask
                              className={
                                errors.totalExperiance !== ""
                                  ? "error-red form-control"
                                  : "form-control"
                              }
                              mask={
                                consultantData.totalExperiance !== ""
                                  ? "99.99"
                                  : ""
                              }
                              maskChar=""
                              value={consultantData.totalExperiance}
                              onChange={(e) => {
                                setConsultantData({
                                  ...consultantData,
                                  totalExperiance: e.target.value,
                                });
                                setErrors({
                                  ...errors,
                                  totalExperiance: "",
                                });
                              }}
                            /> */}
                            <span
                              className="error-msg"
                              style={{ color: "red" }}
                            >
                              {errors.totalExperiance}
                            </span>
                          </Form.Group>
                        </Col>
                        <Col lg="4" md="6">
                          <Form.Group controlId="formCurrentSalary">
                            <Form.Label>
                              Current Salary(IN LPA)
                              <span className="text-danger">&nbsp;*</span>
                            </Form.Label>
                            <Form.Control
                              type="number"
                              disabled={!file}
                              className={
                                errors.currentSalary !== ""
                                  ? "error-red form-control"
                                  : !file
                                  ? "disabled-field form-control"
                                  : "form-control"
                              }
                              value={consultantData.currentSalary}
                              onChange={(e) => {
                                setConsultantData({
                                  ...consultantData,
                                  currentSalary: e.target.value,
                                });
                                setErrors({
                                  ...errors,
                                  currentSalary: "",
                                });
                              }}
                              onKeyDown={(evt) =>
                                ["e", "E", "+", "-"].includes(evt.key) &&
                                evt.preventDefault()
                              }
                              onInput={(e) => {
                                if (e.target.value.length > e.target.maxLength)
                                  e.target.value = e.target.value.slice(
                                    0,
                                    e.target.maxLength
                                  );
                              }}
                              maxlength={5}
                            />
                            {/* <InputMask
                              className={
                                errors.currentSalary !== ""
                                  ? "error-red form-control"
                                  : "form-control"
                              }
                              mask={
                                consultantData.currentSalary !== ""
                                  ? "99.99"
                                  : ""
                              }
                              maskChar=""
                              value={consultantData.currentSalary}
                              onChange={(e) => {
                                setConsultantData({
                                  ...consultantData,
                                  currentSalary: e.target.value,
                                });
                                setErrors({
                                  ...errors,
                                  currentSalary: "",
                                });
                              }}
                            />
                            */}
                            <span
                              className="error-msg"
                              style={{ color: "red" }}
                            >
                              {errors.currentSalary}
                            </span>
                          </Form.Group>
                        </Col>
                        <Col lg="8" md="12">
                          <Form.Group controlId="formEmail">
                            <Form.Label>Skill Set</Form.Label>
                            <MultiSelectComponent
                              name="skillSet"
                              options={skillSetOption}
                              values={selectedSkill}
                              disabled={!file}
                              className={!file ? "disabled-field" : ""}
                              onValuesChange={(e) => {
                                let list = [];
                                e.map((item) => list.push(item.value));
                                e &&
                                  setConsultantData({
                                    ...consultantData,
                                    skillSet: list,
                                  });
                                setSelectedSkill(e);
                              }}
                              onSearchChange={(e) => {
                                getSkillSetList(e);
                              }}
                              onRemoveItem={function (item) {
                                const skills = selectedSkill?.filter(function (
                                  d
                                ) {
                                  return item.value !== d?.value;
                                });
                                setSelectedSkill(skills);
                              }}
                            ></MultiSelectComponent>
                          </Form.Group>
                        </Col>
                        {walkinStatus?.data?.isWalkInDrive && (
                          <Col lg="4" md="6">
                            <Form.Group controlId="formWalk-inDrive ">
                              <Form.Label>
                                Candidate walk-in drive source :
                              </Form.Label>
                              <SimpleSelectComponent
                                // options={walkinDriveSourceOption}
                                name="walkinDriveSource"
                                className={!file ? "disabled-field" : ""}
                                disabled={!file}
                                value={consultantData.walkinDriveSource}
                                // defaultValue={{
                                //   value: consultantData?.walkinDriveSourceId,
                                //   label: consultantData?.walkinDriveSource,
                                // }}
                                onValueChange={(e) => {
                                  e &&
                                    setConsultantData({
                                      ...consultantData,
                                      walkinDriveSourceId: e,
                                      walkinDriveSource: e,
                                    });
                                }}
                                // onSearchChange={(e) => {
                                //   getWalkInDriveList(e);
                                // }}
                              >
                                {walkinDriveSourceDetail?.map((data) => (
                                  <option value={data._id}>
                                    {data.walkInDrive}
                                  </option>
                                ))}
                              </SimpleSelectComponent>
                            </Form.Group>
                          </Col>
                        )}
                      </Row>
                    </div>
                    </div>
                    {/* Ends: Professional Details */}

                    {/* Begin: Educational Details */}
                    {/* <div className="form-fields educational-details">
                        <h2 className="title">Educational Details</h2>
                        <React.Fragment>
                          {educationDetails &&
                            educationDetails.map((i, index) => {
                              return (
                                Object.keys(i).includes("institute") && (
                                  <Form className="form repeater-default add-columns-btn">
                                    <div className="field-form" key={index}>
                                      <Row>
                                        <Col xs={6} lg={6}>
                                          <Form.Group>
                                            <Form.Label>
                                              Institute / School
                                            </Form.Label>
                                            <Form.Control
                                              type="text"
                                              autoComplete="off"
                                              name="institute"
                                              value={i.institute}
                                              onChange={(e) =>
                                                handleEducationDetails(
                                                  e.target.value,
                                                  index,
                                                  "institute"
                                                )
                                              }
                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col xs={6} lg={6}>
                                          <Form.Group>
                                            <Form.Label>
                                              Major / Department
                                            </Form.Label>
                                            <Form.Control
                                              type="text"
                                              autoComplete="off"
                                              name="major"
                                              value={i.major}
                                              onChange={(e) =>
                                                handleEducationDetails(
                                                  e.target.value,
                                                  index,
                                                  "major"
                                                )
                                              }
                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col xs={6} lg={6}>
                                          <Form.Group>
                                            <Form.Label>Degree</Form.Label>
                                            <Form.Control
                                              type="text"
                                              autoComplete="off"
                                              name="degree"
                                              value={i.degree}
                                              onChange={(e) =>
                                                handleEducationDetails(
                                                  e.target.value,
                                                  index,
                                                  "degree"
                                                )
                                              }
                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col xs={6} lg={6}>
                                          <Form.Group>
                                            <Form.Label>Duration</Form.Label>
                                            <Row>
                                              <Col sm={6}>
                                                <DatePicker
                                                  placeholderText="From"
                                                  className="form-control"
                                                  value={i.from}
                                                  onChange={(date) => {
                                                    handleEducationDetails(
                                                      moment(date).format(
                                                        "MM/yyyy"
                                                      ),
                                                      index,
                                                      "from"
                                                    );
                                                    setStartMonth(
                                                      new Date(date)
                                                    );
                                                    i.to = "";
                                                  }}
                                                  selectsStart
                                                  dateFormat="MM/yyyy"
                                                  showMonthYearPicker
                                                />
                                              </Col>

                                              <Col sm={6}>
                                                <DatePicker
                                                  placeholderText="To"
                                                  className="form-control"
                                                  value={
                                                    i.pursuing !== true
                                                      ? i.to
                                                      : "Present"
                                                  }
                                                  minDate={startMonth}
                                                  disabled={i.pursuing === true}
                                                  onChange={(date) => {
                                                    handleEducationDetails(
                                                      moment(date).format(
                                                        "MM/YYYY"
                                                      ),
                                                      index,
                                                      "to"
                                                    );
                                                  }}
                                                  selectsStart
                                                  dateFormat="MM/yyyy"
                                                  showMonthYearPicker
                                                />
                                              </Col>
                                            </Row>
                                            <div className="custom-checkbox text-right mt-2">
                                              <label
                                                className="form-label"
                                                htmlFor={`pursuing${index}`}
                                              >
                                                Currently Pursuing
                                                <input
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  name="pursuing"
                                                  id={`pursuing${index}`}
                                                  checked={i.pursuing}
                                                  onChange={(e) => {
                                                    handleEducationDetails(
                                                      e.target.checked,
                                                      index,
                                                      "pursuing"
                                                    );
                                                  }}
                                                />
                                                <span></span>
                                              </label>
                                            </div>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                    {btnForm.educationDetails && (
                                      <div className="add-row text-right">
                                        {educationDetails.length - 1 ===
                                          index && (
                                          <span
                                            className="bx bxs-plus-circle text-success"
                                            title="Add"
                                            onClick={(e) => {
                                              handleAddEducation(e);
                                            }}
                                          >
                                            <span className="btn-text">
                                              Add
                                            </span>
                                          </span>
                                        )}
                                        {educationDetails.length !== 1 && (
                                          <span
                                            className="bx bxs-minus-circle text-danger"
                                            title="Delete"
                                            onClick={() =>
                                              handleRemoveEducation(index)
                                            }
                                          >
                                            <span className="btn-text">
                                              Remove
                                            </span>
                                          </span>
                                        )}
                                      </div>
                                    )}
                                  </Form>
                                )
                              );
                            })}
                        </React.Fragment>
                      </div> */}
                    {/* Ends: Educational Details */}

                    {/* <div className="divider-x"></div> */}

                    {/* Begin: Experience Details */}
                    {/* <div className="form-fields experience-details">
                        <h2 className="title">Experience Details</h2>
                        <React.Fragment>
                          {experienceDetails &&
                            experienceDetails.map((i, index) => {
                              return (
                                Object.keys(i).includes("company") && (
                                  <Form className="form repeater-default add-columns-btn">
                                    <div className="field-form" key={index}>
                                      <Row>
                                        <Col xs={6} lg={6}>
                                          <Form.Group>
                                            <Form.Label>
                                              Occupation / Title
                                            </Form.Label>
                                            <Form.Control
                                              type="text"
                                              autoComplete="off"
                                              name="occupation"
                                              value={i.occupation}
                                              onChange={(e) =>
                                                handleExpDetail(
                                                  e.target.value,
                                                  index,
                                                  "occupation"
                                                )
                                              }
                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col xs={6} lg={6}>
                                          <Form.Group>
                                            <Form.Label>Company</Form.Label>
                                            <Form.Control
                                              type="text"
                                              autoComplete="off"
                                              name="company"
                                              value={i.company}
                                              onChange={(e) =>
                                                handleExpDetail(
                                                  e.target.value,
                                                  index,
                                                  "company"
                                                )
                                              }
                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col xs={6} lg={6}>
                                          <Form.Group>
                                            <Form.Label>Summary</Form.Label>
                                            <Form.Control
                                              as="textarea"
                                              rows="2"
                                              name="summary"
                                              value={i.summary}
                                              onChange={(e) =>
                                                handleExpDetail(
                                                  e.target.value,
                                                  index,
                                                  "summary"
                                                )
                                              }
                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col xs={6} lg={6}>
                                          <Form.Group>
                                            <Form.Label>
                                              Work Duration
                                            </Form.Label>
                                            <Row>
                                              <Col sm={6}>
                                                <DatePicker
                                                  placeholderText="From"
                                                  className="form-control"
                                                  value={i.from}
                                                  onChange={(date) => {
                                                    handleExpDetail(
                                                      moment(date).format(
                                                        "MM/yyyy"
                                                      ),
                                                      index,
                                                      "from"
                                                    );
                                                    setExperienceStartMont(
                                                      new Date(date)
                                                    );
                                                    i.to = "";
                                                  }}
                                                  selectsStart
                                                  dateFormat="MM/yyyy"
                                                  showMonthYearPicker
                                                />
                                              </Col>
                                              <Col sm={6}>
                                                <DatePicker
                                                  placeholderText="To"
                                                  className="form-control"
                                                  value={
                                                    i.isWorking !== true
                                                      ? i.to
                                                      : "Present"
                                                  }
                                                  minDate={experienceStartMonth}
                                                  disabled={
                                                    i.isWorking === true
                                                  }
                                                  onChange={(date) => {
                                                    handleExpDetail(
                                                      moment(date).format(
                                                        "MM/yyyy"
                                                      ),
                                                      index,
                                                      "to"
                                                    );
                                                  }}
                                                  selectsStart
                                                  dateFormat="MM/yyyy"
                                                  showMonthYearPicker
                                                />
                                              </Col>
                                            </Row>
                                            <div className="custom-checkbox text-right mt-2">
                                              <label
                                                className="form-label"
                                                htmlFor={`isWorking${index}`}
                                              >
                                                I currently work here
                                                <input
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  name="isWorking"
                                                  id={`isWorking${index}`}
                                                  checked={i.isWorking}
                                                  onChange={(e) => {
                                                    handleExpDetail(
                                                      e.target.checked,
                                                      index,
                                                      "isWorking"
                                                    );
                                                  }}
                                                />
                                                <span></span>
                                              </label>
                                            </div>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                    <div className="add-row text-right">
                                      {experienceDetails.length - 1 ===
                                        index && (
                                        <span
                                          className="bx bxs-plus-circle text-success"
                                          title="Add"
                                          onClick={(e) => {
                                            handleExeperienceAdd(e);
                                          }}
                                        >
                                          <span className="btn-text">Add</span>
                                        </span>
                                      )}
                                      {experienceDetails.length !== 1 && (
                                        <span
                                          className="bx bxs-minus-circle text-danger"
                                          title="Delete"
                                          onClick={() =>
                                            handleRemoveExperience(index)
                                          }
                                        >
                                          <span className="btn-text">
                                            Remove
                                          </span>
                                        </span>
                                      )}
                                    </div>
                                  </Form>
                                )
                              );
                            })}
                        </React.Fragment>
                      </div> */}
                    {/* Ends: Experience Details */}

                    {/* <div className="divider-x"></div> */}

                    {/* Begin: Address Details */}
                    <div className={activeStep === 3 ? "" : "d-none"}>
                    <div className="panel-header" id="nic-address">
                      <h4 className="nic-section-title">
                        <span className="nic-section-badge">4</span>
                        Address Details
                      </h4>
                    </div>

                    <div className="panel-content py-0">
                      <Row>
                        <Col lg="4" md="6">
                          <Form.Group controlId="formStreet">
                            <Form.Label>Street</Form.Label>
                            <Form.Control
                              type="text"
                              name="street"
                              maxLength="45 "
                              value={consultantData.street}
                              onChange={(e) => {
                                handleDataChange(e);
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col lg="4" md="6">
                          <Form.Group controlId="formZip">
                            <Form.Label>Zip / Postal Code</Form.Label>
                            <InputMask
                              className="form-control"
                              mask={
                                consultantData.zipCode !== "" ? "999999" : ""
                              }
                              maskChar=""
                              value={consultantData.zipCode}
                              onChange={(e) =>
                                setConsultantData({
                                  ...consultantData,
                                  zipCode: e.target.value,
                                })
                              }
                            />
                            {/* <Form.Control
                                type="number"
                                name="zipCode"
                                onWheel={(e) => e.target.blur()}
                                onChange={(e) => {
                                  setConsultantData({
                                    ...consultantData,
                                    zipCode: e.target.value,
                                  });
                                }}
                              /> */}
                          </Form.Group>
                        </Col>
                        <Col lg="4" md="6">
                          <Form.Group controlId="formCity">
                            <Form.Label>
                              City<span className="text-danger">&nbsp;*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="city"
                              maxLength="30"
                              className={errors.city !== "" ? "error-red" : ""}
                              value={consultantData.city}
                              onChange={(e) => {
                                handleDataChange(e);
                                setErrors({
                                  ...errors,
                                  city: "",
                                });
                              }}
                            />
                            <span
                              className="error-msg"
                              style={{ color: "red" }}
                            >
                              {errors.city}
                            </span>
                          </Form.Group>
                        </Col>
                        <Col lg="4" md="6">
                          <Form.Group controlId="formProvince">
                            <Form.Label>State / Province</Form.Label>
                            <Form.Control
                              type="text"
                              name="state"
                              maxLength="30"
                              value={consultantData.state}
                              onChange={(e) => {
                                handleDataChange(e);
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col lg="4" md="6">
                          <Form.Group controlId="formCountry">
                            <Form.Label>Country</Form.Label>
                            <Form.Control
                              type="text"
                              name="country"
                              maxLength="30"
                              value={consultantData.country}
                              onChange={(e) => {
                                handleDataChange(e);
                              }}
                            />{" "}
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                    </div>
                    {/* Ends: Address Details */}

                    {/* <div className="divider-x"></div> */}

                    {/* Begin: Social Network Details */}
                    {/* <div className="form-fields social-network-details">
                        <Row>
                          <Col md="12">
                            <h4 className="title">Social Network</h4>
                          </Col>
                          <Col lg="4" md="6">
                            <Form.Group controlId="formLinkedIn">
                              <Form.Label>LinkedIn</Form.Label>
                              <Form.Control
                                type="text"
                                name="linkdin"
                                maxLength="30"
                                value={consultantData.linkdin}
                                onChange={(e) => {
                                  handleDataChange(e, "num");
                                }}
                              />
                            </Form.Group>
                          </Col>
                          <Col lg="4" md="6">
                            <Form.Group controlId="formFacebook">
                              <Form.Label>Facebook</Form.Label>
                              <Form.Control
                                type="text"
                                name="faceBook"
                                maxLength="30"
                                value={consultantData.faceBook}
                                onChange={(e) => {
                                  handleDataChange(e, "num");
                                }}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </div> */}
                    {/* Ends: Social Network Details */}
                  </div>

                  {/* Begin: Submit Button */}
                  <div
                    className={`button-group nic-actions ${
                      activeStep === 0 && uploadMode === "bulk" ? "d-none" : ""
                    }`}
                  >
                    {activeStep > 0 && (
                      <Button
                        variant="outline-secondary"
                        type="button"
                        className="nic-btn-clear mr-auto"
                        onClick={handleBack}
                      >
                        <span className="bx bx-left-arrow-alt"></span> Back
                      </Button>
                    )}
                    {activeStep === formSteps.length - 1 ? (
                      <Button
                        variant="dark"
                        type="submit"
                        className="nic-btn-submit"
                        disabled={isLoading}
                      >
                        Submit <span className="bx bx-right-arrow-alt"></span>
                      </Button>
                    ) : (
                      <Button
                        variant="dark"
                        type="button"
                        className="nic-btn-submit"
                        onClick={handleNext}
                        disabled={
                          parsingResume ||
                          replacingResume ||
                          (activeStep === 0 && !file)
                        }
                      >
                        Next <span className="bx bx-right-arrow-alt"></span>
                      </Button>
                    )}
                    {isLoading && (
                      <Spinner
                        animation="border"
                        variant="primary"
                        className="spinner-loader"
                      />
                    )}
                  </div>
                  {/* Ends: Submit Button */}
                </Form>
                {/* Form Fields Ends */}
              </Col>
            </Row>
          </div>
        </section>
        {/* Ends: Form */}
        </div>

        <input
          type="file"
          ref={replaceInput}
          accept=".pdf,.doc,.docx"
          className="d-none"
          onChange={onReplaceFileSelected}
        />
        <Modal
          show={showDuplicate}
          onHide={() => setShowDuplicate(false)}
          centered
          className="nic-cform-replace-modal nic-confirm-modal"
        >
          <Modal.Body>
            <span className="nic-confirm-icon">
              <span className="bx bx-error"></span>
            </span>
            <h5 className="nic-confirm-title">Candidate already exists</h5>
            <p>
              A candidate with these details has already been added. Do you
              want to add another candidate?
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="outline-dark"
              className="nic-replace-btn"
              onClick={() => setShowDuplicate(false)}
            >
              No
            </Button>
            <Button
              className="nic-replace-btn nic-replace-primary"
              onClick={() => {
                setShowDuplicate(false);
                resetData();
              }}
            >
              Yes, add another
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={showDocPreview}
          onHide={() => setShowDocPreview(false)}
          centered
          size="lg"
          className="nic-cform-replace-modal nic-doc-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>{file && file.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div ref={docPreviewRef} className="nic-doc-preview"></div>
          </Modal.Body>
        </Modal>
        <Modal
          show={showCamera}
          onHide={closeCamera}
          centered
          className="nic-cform-replace-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Capture photo</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <video
              className="nic-camera-video"
              autoPlay
              playsInline
              muted
              ref={(el) => {
                videoRef.current = el;
                if (el && streamRef.current && el.srcObject !== streamRef.current) {
                  el.srcObject = streamRef.current;
                }
              }}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="outline-dark"
              className="nic-replace-btn"
              onClick={closeCamera}
            >
              Cancel
            </Button>
            <Button
              className="nic-replace-btn nic-replace-primary"
              onClick={takePhoto}
            >
              Capture
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={showReplace}
          onHide={() => setShowReplace(false)}
          centered
          className="nic-cform-replace-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Replace resume</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Do you want to update only the resume file, or also update your
            profile details based on the new resume?
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="outline-dark"
              className="nic-replace-btn"
              onClick={() => chooseReplaceMode("only")}
            >
              Only resume
            </Button>
            <Button
              className="nic-replace-btn nic-replace-primary"
              onClick={() => chooseReplaceMode("all")}
            >
              Resume + profile data
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <div className="text-center mb-4">
              <span className="bx bx-check-circle"></span>
              <h5 className="text-secondary">Success!</h5>
            </div>
            {/* <Modal.Title>Modal heading</Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            <p>
              {addJob &&
                addJob.data &&
                addJob.data.firstName + " " + addJob.data.lastName}
              ,
            </p>
            <p className="">
              Thank you for applying and sharing the information.
            </p>
            <p>
              Our team will get in touch with you soon. If you have submitted
              details with no current openings with us at the moment, please
              look out for any emails from IndiaNIC. We will be in touch with
              you when appropriate vacancies open up.
            </p>
            <p className="mb-2">
              To know more about IndiaNIC - visit{" "}
              <a href="candidate-portal-indianic.com" target="_blank">
                https://www.indianic.com
              </a>
            </p>
            <p>
              Your further updates will be send to your{" "}
              <a
                href="http://www.google.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                {addJob && addJob.data && addJob.data.emailId}
              </a>{" "}
            </p>
            <h5 className="font-weight-semibold">HR Team</h5>
            <p className="font-weight-medium">
              Have a Good Day and Best wishes for your further process.
            </p>
            {/* <img src={bgImg} alt="Career Page Header" /> */}
            <p>+91 (79) 6191 6041</p>
            <p>+1 (408) 922-9083</p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={resetData}>Ok</Button>
            {/* <Button variant="secondary" onClick={handleClose}>
                    Close
                  </Button>
                  <Button variant="primary" onClick={handleClose}>
                    Save Changes
                  </Button> */}
          </Modal.Footer>
        </Modal>
        </main>
      </div>
      <footer className="nic-footer">
        <p className="nic-footer-brand">Candidate Portal</p>
        <p>IndiaNIC Infotech Limited © {new Date().getFullYear()}</p>
      </footer>
      </div>
    </React.Fragment>
  );
};

export default ConsultantForm;
